"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOnDemandProgrammeToEntityEdgeTypeMatrixEntry = exports.getOnDemandProgrammeToEntityEdgeTypeId = exports.getEntityRollingProgrammeToEntityEdgeTypeMatrixEntry = exports.getEntityRollingProgrammeToEntityEdgeTypeId = exports.getEntityProgrammeToEntityEdgeTypeMatrixEntry = exports.getEntityProgrammeToEntityEdgeTypeId = exports.getEntityNetworkToTypeEdgeTypeMatrixEntry = exports.getEntityNetworkToEntityEdgeTypeId = exports.getPropertyToEntityEdgeTypeMatrixEntry = exports.getEntityToPlaceEdgeTypeMatrixEntry = exports.getEntityToPlaceEdgeTypeId = exports.getGroupToEntityEdgeTypeId = exports.getParentToChildEdgeTypeMatrixEntry = exports.getEntityToScoreConfigEdgeTypeMatrixEntry = exports.getEntityToDeviceEdgeTypeMatrixEntry = exports.getEntityToDeviceEdgeTypeMatrixEntryNamed = exports.getAreaToEntityMatrixEntry = exports.getEntityToScoreConfigEdgeTypeId = exports.getEntityToDeviceEdgeTypeId = exports.getGroupToTypeEdgeTypeMatrixEntry = exports.getObjectTypeHasGroupEdgeTypeId = void 0;
const core_services_1 = require("@iotv/core-services");
const Scoring_1 = require("../../model/Scoring");
/** returns canonical form for X has Group, note this is lowercase */
const getObjectTypeHasGroupEdgeTypeId = (objectTypeId) => `${objectTypeId.toLowerCase()}_has_group`;
exports.getObjectTypeHasGroupEdgeTypeId = getObjectTypeHasGroupEdgeTypeId;
/** returns a edgeTypeMatrix entry for a given Group - Class
 * If this is retro-fitted to existing datamodel edgeTypeMatrix, care (and unit tests) required not to change existing edgeTypeIds
 */
const getGroupToTypeEdgeTypeMatrixEntry = (objectTypeId) => {
    const edgeTypeId = `group_has_${objectTypeId}`;
    const edgeDefinition = {
        edgeTypeId,
        labels: {
            out: `has ${(0, core_services_1.readableTypeName)(objectTypeId)}`,
            in: `is ${(0, core_services_1.readableTypeName)(objectTypeId)} in group`,
        },
        cardinality: {
            out: null,
            in: null,
        },
    };
    const entry = {
        [objectTypeId]: {
            [edgeTypeId]: edgeDefinition,
        },
    };
    return entry;
};
exports.getGroupToTypeEdgeTypeMatrixEntry = getGroupToTypeEdgeTypeMatrixEntry;
const getEntityToDeviceEdgeTypeId = (enityType) => `${enityType.toLowerCase()}_has_Device`;
exports.getEntityToDeviceEdgeTypeId = getEntityToDeviceEdgeTypeId;
const getEntityToScoreConfigEdgeTypeId = (entityType) => `${entityType.toLowerCase()}_has_${Scoring_1.ScoreConfigClassName}`;
exports.getEntityToScoreConfigEdgeTypeId = getEntityToScoreConfigEdgeTypeId;
const getAreaToEntityMatrixEntry = (objectTypeId) => {
    const edgeTypeId = `area_has_${objectTypeId.toLowerCase()}`;
    const edgeDefinition = {
        edgeTypeId,
        labels: {
            out: `has ${(0, core_services_1.readableTypeName)(objectTypeId)}`,
            in: `is ${(0, core_services_1.readableTypeName)(objectTypeId)} in area`,
        },
        cardinality: {
            out: null,
            in: null,
        },
    };
    const entry = {
        [objectTypeId]: {
            [edgeTypeId]: edgeDefinition,
        },
    };
    return entry;
};
exports.getAreaToEntityMatrixEntry = getAreaToEntityMatrixEntry;
const getEntityToDeviceEdgeTypeMatrixEntryNamed = (entityType) => {
    const edgeTypeId = (0, exports.getEntityToDeviceEdgeTypeId)(entityType);
    const edgeDefinition = {
        edgeTypeId,
        labels: {
            out: `has Device`,
            in: `is Device for ${(0, core_services_1.readableTypeName)(entityType)}`,
        },
        cardinality: {
            out: null,
            in: 1,
        },
    };
    const entry = {
        Device: {
            [edgeTypeId]: edgeDefinition,
        },
    };
    return { [entityType]: entry };
};
exports.getEntityToDeviceEdgeTypeMatrixEntryNamed = getEntityToDeviceEdgeTypeMatrixEntryNamed;
const getEntityToDeviceEdgeTypeMatrixEntry = (entityType) => {
    const edgeTypeId = (0, exports.getEntityToDeviceEdgeTypeId)(entityType);
    const edgeDefinition = {
        edgeTypeId,
        labels: {
            out: `has Device`,
            in: `is Device for ${(0, core_services_1.readableTypeName)(entityType)}`,
        },
        cardinality: {
            out: null,
            in: 1,
        },
    };
    const entry = {
        Device: {
            [edgeTypeId]: edgeDefinition,
        },
    };
    return entry;
};
exports.getEntityToDeviceEdgeTypeMatrixEntry = getEntityToDeviceEdgeTypeMatrixEntry;
const getEntityToScoreConfigEdgeTypeMatrixEntry = (entityType) => {
    const edgeTypeId = (0, exports.getEntityToScoreConfigEdgeTypeId)(entityType);
    const edgeDefinition = {
        edgeTypeId,
        labels: {
            out: `has ScoreConfig`,
            in: `is ScoreConfig for ${(0, core_services_1.readableTypeName)(entityType)}`,
        },
        cardinality: {
            out: 1,
            in: 1,
        },
    };
    const entry = {
        ScoreConfig: {
            [edgeTypeId]: edgeDefinition,
        },
    };
    return entry;
};
exports.getEntityToScoreConfigEdgeTypeMatrixEntry = getEntityToScoreConfigEdgeTypeMatrixEntry;
const getParentToChildEdgeTypeMatrixEntry = (parentId, childId) => {
    const edgeTypeId = `${parentId}_has_${childId}`.toLowerCase();
    const edgeDefinition = {
        edgeTypeId,
        labels: {
            out: `has ${childId}`,
            in: `is ${childId} in ${parentId}`,
        },
        cardinality: {
            out: null,
            in: null,
        },
    };
    const entry = {
        [childId]: {
            [edgeTypeId]: edgeDefinition,
        },
    };
    return entry;
};
exports.getParentToChildEdgeTypeMatrixEntry = getParentToChildEdgeTypeMatrixEntry;
const getGroupToEntityEdgeTypeId = (objectTypeId) => `group_has_${objectTypeId}`;
exports.getGroupToEntityEdgeTypeId = getGroupToEntityEdgeTypeId;
const getEntityToPlaceEdgeTypeId = (entityType) => `${entityType.toLowerCase()}_has_Place`;
exports.getEntityToPlaceEdgeTypeId = getEntityToPlaceEdgeTypeId;
const getEntityToPlaceEdgeTypeMatrixEntry = (entityType) => {
    const edgeTypeId = (0, exports.getEntityToPlaceEdgeTypeId)(entityType);
    const edgeDefinition = {
        edgeTypeId,
        labels: {
            out: `has Place`,
            in: `is Place for ${(0, core_services_1.readableTypeName)(entityType)}`,
        },
        cardinality: {
            out: null,
            in: null,
        },
    };
    const entry = {
        Place: {
            [edgeTypeId]: edgeDefinition,
        },
    };
    return entry;
};
exports.getEntityToPlaceEdgeTypeMatrixEntry = getEntityToPlaceEdgeTypeMatrixEntry;
const getPropertyToEntityEdgeTypeMatrixEntry = (objectTypeId) => {
    const edgeTypeId = `property_has_${objectTypeId}`;
    const edgeDefinition = {
        edgeTypeId,
        labels: {
            out: `has ${(0, core_services_1.readableTypeName)(objectTypeId)}`,
            in: `is ${(0, core_services_1.readableTypeName)(objectTypeId)} in property`,
        },
        cardinality: {
            out: null,
            in: null,
        },
    };
    const entry = {
        [objectTypeId]: {
            [edgeTypeId]: edgeDefinition,
        },
    };
    return entry;
};
exports.getPropertyToEntityEdgeTypeMatrixEntry = getPropertyToEntityEdgeTypeMatrixEntry;
const getEntityNetworkToEntityEdgeTypeId = (objectTypeId) => `entity_network_includes_${objectTypeId}`;
exports.getEntityNetworkToEntityEdgeTypeId = getEntityNetworkToEntityEdgeTypeId;
const getEntityNetworkToTypeEdgeTypeMatrixEntry = (objectTypeId) => {
    const edgeTypeId = (0, exports.getEntityNetworkToEntityEdgeTypeId)(objectTypeId);
    const edgeDefinition = {
        edgeTypeId,
        labels: {
            out: `includes ${(0, core_services_1.readableTypeName)(objectTypeId)}`,
            in: `is included in Entity Network`,
        },
        cardinality: {
            out: null,
            in: null,
        },
    };
    const entry = {
        [objectTypeId]: {
            [edgeTypeId]: edgeDefinition,
        },
    };
    return entry;
};
exports.getEntityNetworkToTypeEdgeTypeMatrixEntry = getEntityNetworkToTypeEdgeTypeMatrixEntry;
const getEntityProgrammeToEntityEdgeTypeId = (objectTypeId) => `programme_schedules_${objectTypeId}`;
exports.getEntityProgrammeToEntityEdgeTypeId = getEntityProgrammeToEntityEdgeTypeId;
const getEntityProgrammeToEntityEdgeTypeMatrixEntry = (objectTypeId) => {
    const edgeTypeId = (0, exports.getEntityProgrammeToEntityEdgeTypeId)(objectTypeId);
    const edgeDefinition = {
        edgeTypeId,
        labels: {
            out: `schedules`,
            in: `is scheduled by Sequential Programme`,
        },
        cardinality: {
            out: null,
            in: null,
        },
    };
    const entry = {
        [objectTypeId]: {
            [edgeTypeId]: edgeDefinition,
        },
    };
    return entry;
};
exports.getEntityProgrammeToEntityEdgeTypeMatrixEntry = getEntityProgrammeToEntityEdgeTypeMatrixEntry;
const getEntityRollingProgrammeToEntityEdgeTypeId = (objectTypeId) => `rolling_programme_schedules_${objectTypeId}`;
exports.getEntityRollingProgrammeToEntityEdgeTypeId = getEntityRollingProgrammeToEntityEdgeTypeId;
const getEntityRollingProgrammeToEntityEdgeTypeMatrixEntry = (objectTypeId) => {
    const edgeTypeId = (0, exports.getEntityRollingProgrammeToEntityEdgeTypeId)(objectTypeId);
    const edgeDefinition = {
        edgeTypeId,
        labels: {
            out: 'schedules',
            in: 'is scheduled by Rolling Programme',
        },
        cardinality: {
            out: null,
            in: null,
        },
    };
    const entry = {
        [objectTypeId]: {
            [edgeTypeId]: edgeDefinition,
        },
    };
    return entry;
};
exports.getEntityRollingProgrammeToEntityEdgeTypeMatrixEntry = getEntityRollingProgrammeToEntityEdgeTypeMatrixEntry;
const getOnDemandProgrammeToEntityEdgeTypeId = (objectTypeId) => `on_demand_programme_sequences_${objectTypeId}`;
exports.getOnDemandProgrammeToEntityEdgeTypeId = getOnDemandProgrammeToEntityEdgeTypeId;
const getOnDemandProgrammeToEntityEdgeTypeMatrixEntry = (objectTypeId) => {
    const edgeTypeId = (0, exports.getOnDemandProgrammeToEntityEdgeTypeId)(objectTypeId);
    const edgeDefinition = {
        edgeTypeId,
        labels: {
            out: 'schedules',
            in: 'is scheduled by On-Demand Programme',
        },
        cardinality: {
            out: null,
            in: null,
        },
    };
    const entry = {
        [objectTypeId]: {
            [edgeTypeId]: edgeDefinition,
        },
    };
    return entry;
};
exports.getOnDemandProgrammeToEntityEdgeTypeMatrixEntry = getOnDemandProgrammeToEntityEdgeTypeMatrixEntry;
